import PropTypes from 'prop-types';
import classNames from 'classnames';

import Price from '@components/Price';
import { toNumber } from 'lodash';
import c from 'currency.js';
import { useTranslation } from 'next-i18next';
import {
  Root,
  Left,
  Right,
  OrderItemBoxes,
  HeaderBox,
  Credit,
} from './InvoiceOrderItems.module.css';
import OrderItem from './components/OrderItem';

const InvoiceOrderItems = ({ className, items, isPreOrder, orderPrice }) => {
  const { t } = useTranslation(['account', 'common']);
  const classes = classNames(Root, className);

  return (
    <div className={classes}>
      <div className={OrderItemBoxes}>
        {Object.entries(items).map(([licensePlate, item], idx, arr) => (
          <OrderItem
            item={item}
            licensePlate={licensePlate}
            key={licensePlate}
            discount={idx === arr.length - 1 && orderPrice.discount}
          />
        ))}
      </div>
      <div className={HeaderBox}>
        <div className={Left}>
          <div>
            {!isPreOrder
              ? t('paid', { ns: 'common' })
              : t('payLater.0', { ns: 'common' })}
          </div>
          {orderPrice.credit && (
            <div className={Credit}>
              {t('receivables', { ns: 'common' })}{' '}
              <div>{t('creditWashback', { ns: 'checkout' })}</div>
            </div>
          )}
        </div>
        <div className={Right}>
          <div>
            <Price
              amount={toNumber(c(orderPrice?.total, { fromCents: true }))}
              showDecimals
            />
          </div>
          {orderPrice.credit && (
            <div className={Credit}>
              <Price
                amount={c(orderPrice.credit, { fromCents: true })}
                showDecimals
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

OrderItem.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Array),
  ]),
};

OrderItem.defaultProps = {
  className: '',
};

export default InvoiceOrderItems;
